import React from "react";
import Accordion from "react-bootstrap/Accordion";

const faqData = [
  {
    question: "Kako objavim izdelek na Bazarcu?",
    answer:
      "Preprosto! Ustvarite si račun, kliknite na 'Objavi oglas' in sledite navodilom. V nekaj minutah je vaš izdelek na ogled.",
  },
  {
    question: "Ali moram plačati za objavo oglasa?",
    answer:
      "Osnovna objava je brezplačna.",
  },
  {
    question: "Kako poteka nakup?",
    answer:
      "Ko najdete izdelek, ki vas zanima, stopite v stik s prodajalcem preko sporočil na platformi in se dogovorite za podrobnosti o nakupu.",
  },
  {
    question: "Ali Bazarc posreduje pri prodaji?",
    answer:
      "Ne, Bazarc je le platforma za povezovanje kupcev in prodajalcev. Ne sodelujemo pri sami transakciji in ne jamčimo za izdelke.",
  },
  {
    question: "Kako prijavim neprimeren oglas?",
    answer:
      "Vsak oglas ima možnost 'Prijavi oglas'. Naša ekipa bo pregledala prijavo in po potrebi ukrepala.",
  },
];

const FAQPage = () => {
  return (
    <div className="container py-5">
      <h1 className="text-center mb-4">Pogosta vprašanja (FAQ)</h1>
      <Accordion defaultActiveKey="0">
        {faqData.map((item, index) => (
          <Accordion.Item eventKey={index.toString()} key={index}>
            <Accordion.Header><strong>{item.question}</strong></Accordion.Header>
            <Accordion.Body>{item.answer}</Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
};

export default FAQPage;